// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c2d72fb5","453":"055b73eb","455":"731af608"}[chunkId] + ".chunk.js";
};